import { render, staticRenderFns } from "./SparePartTab.vue?vue&type=template&id=32fcf604"
import script from "./SparePartTab.vue?vue&type=script&lang=ts"
export * from "./SparePartTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports